import VisitsTable from './VisitsTable';
function makeVisit(overrides = {}) {
    return Object.assign({ id: 1, primary: false, techName: 'Jane Doe', techRole: null, scheduledDateIso: '2026-05-12T10:00:00-04:00', scheduledDateDisplay: '05/12/2026', scheduledTimeDisplay: '10:00 AM', durationDisplay: '2 hours', easyUploadProps: null, editTrigger: {
            updateUrl: '/inspection_visits/1',
            subcontractorModal: false,
            visit: {
                id: 1,
                technicianId: 1,
                subcontractorId: null,
                priority: 'normal',
                priorityNote: null,
                scheduledDate: '05/12/2026',
                scheduledTime: '10:00',
                timeZoneOverride: 'America/New_York',
                duration: 120,
                visitNotes: null
            }
        }, canDelete: true }, overrides);
}
const meta = {
    title: 'Features/Inspections/Show/VisitsTable',
    component: VisitsTable
};
export default meta;
export const Default = {
    args: {
        subcontractorsEnabled: false,
        visits: [
            makeVisit({
                id: 10,
                primary: true,
                techName: 'Alice Primary',
                scheduledDateIso: '2026-05-10T09:00:00-04:00',
                scheduledDateDisplay: '05/10/2026',
                scheduledTimeDisplay: '09:00 AM',
                editTrigger: null,
                canDelete: false
            }),
            makeVisit({
                id: 11,
                techName: 'Bob Tech',
                scheduledDateIso: '2026-05-14T13:00:00-04:00',
                scheduledDateDisplay: '05/14/2026',
                scheduledTimeDisplay: '01:00 PM'
            }),
            makeVisit({
                id: 12,
                techName: 'Carol Tech',
                techRole: '(Service Tech)',
                scheduledDateIso: '2026-05-12T15:30:00-04:00',
                scheduledDateDisplay: '05/12/2026',
                scheduledTimeDisplay: '03:30 PM',
                durationDisplay: '4 hours'
            })
        ]
    }
};
export const WithSubcontractors = {
    args: {
        subcontractorsEnabled: true,
        visits: [
            makeVisit({
                id: 20,
                primary: true,
                techName: 'Inspect Co (Subcontractor)',
                editTrigger: null,
                canDelete: false
            }),
            makeVisit({
                id: 21,
                techName: 'Internal Tech',
                scheduledDateIso: '2026-05-15T08:00:00-04:00',
                scheduledDateDisplay: '05/15/2026',
                scheduledTimeDisplay: '08:00 AM'
            })
        ]
    }
};
export const Empty = {
    args: { subcontractorsEnabled: false, visits: [] }
};
